import {Divider, Paper, Stack, Grid, Typography} from "@mui/material";
import {ArrowRightAlt as ArrowRightAltIcon} from "@mui/icons-material";
import React from "react";
import {useTranslation} from "react-i18next";

interface SlotState {
    state: string;
    workState: {
        new?: string;
        prev?: string;
    };
    card?: {
        number?: string;
    };
    number: number;
}
export interface DTCOProps {
    kafka?: {
        slot1?: SlotState;
        slot2?: SlotState;
    };
    error?: string;
}

const translationKeys = new Map<string, string>([
    ["SLOTSTATE_DRIVER_CARD_PRESENT", "slotstate_driverCardPresent"],
    ["SLOTSTATE_CARD_REMOVED", "slotstate_cardRemoved"],
    ["WORKSTATE_BREAK_REST", "workstate_breakRest"],
    ["WORKSTATE_AVAILABLE", "workstate_available"],
    ["WORKSTATE_WORKING", "workstate_working"],
    ["WORKSTATE_DRIVIN", "workstate_driving"],
    ["WORKSTATE_ERROR", "workstate_error"],
    ["WORKSTATE_NOT_AVAILABLE", "workstate_notAvailable"],
]);

export default function DTCOInfo(props: Readonly<DTCOProps>) {
    const {kafka, error} = props;
    if (kafka === undefined) return <span>{error}</span>;
    const slot1 = kafka?.slot1;
    const slot2 = kafka?.slot2;
    return (
        <>
            {slot1 !== undefined && (
                <>
                    <SlotInfo {...slot1} number={1} />
                    <Divider light />
                </>
            )}
            {slot2 !== undefined && <SlotInfo {...slot2} number={2} />}
        </>
    );
}

function SlotInfo({state, workState, card, number}: Readonly<SlotState>) {
    const {t} = useTranslation();
    const showOldWorkState = workState?.prev && workState?.prev.length > 2;
    const showNewWorkState = workState?.new && workState?.new.length > 2;
    return (
        <Paper elevation={0} sx={{backgroundColor: "transparent", p: 2}}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Typography variant="subtitle2">Slot {number}</Typography>
                    <Typography variant="caption">{card?.number || t(getTranslationKey(state))}</Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                        {showOldWorkState && (
                            <Typography variant="caption" component="span">
                                {t(getTranslationKey(workState?.prev || ""))}
                            </Typography>
                        )}
                        {showOldWorkState && showNewWorkState && <ArrowRightAltIcon fontSize="small" />}
                        {showNewWorkState && (
                            <Typography variant="caption" component="span">
                                {t(getTranslationKey(workState?.new || ""))}
                            </Typography>
                        )}
                    </Stack>
                </Grid>
            </Grid>
        </Paper>
    );
}

function getTranslationKey(state: string) {
    return translationKeys.get(state) || state;
}
